import React, {Component} from 'react';
import {Row, Col, Button, Modal, Container, Form} from 'react-bootstrap';
import Switch from 'react-switch';
import './Licensee.css';

import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

class AddLicensee extends Component {
  constructor() {
    super();
    this.state = {
      value: {
        email: '',
        mobno: '',
        password: '',
        confPwd: '',
        orgName: '',
        country: '',
        states: '',
        district: '',
        address1: '',
        address2: '',
        landmark: '',
        city: '',
        zip: '',
        glCode: '',
        gstin: '',
        currCode: '',
        currencyId: '',
        crno: '',
        crExpirydate: '',
        fname: '',
        lname: '',
        countryCode: '',
        contNum: '',
        spocName: '',
        spocDesign: '',
        spocEmail: '',
        spocPhone: '',
        hqAdd: '',
        hqFax: '',
        hqEmail: '',
        hqPhone: '',
        taxPay: '',
        taxPercent: '',
        commPer: '',
        orgLogo: '',
        isEnabled: false,
      },
      isHidden: true,
      fnameError: '',
      lnameError: '',
      emailError: '',
      passwordError: '',
      confPwdError: '',
      orgNameError: '',
      address1Error: '',
      mobnoError: '',
      countryError: '',
      statesError: '',
      districtError: '',
      gstError: '',
    };
  }

  handleChange = checked => {
    this.setState({
      isHidden: checked ? false : true,
      value: {
        ...this.state.value,
        isEnabled: checked,
        taxPercent: !checked
          ? 0
          : this.state
              .taxPercent /*To show taxpercent as zero, if we populate it first and then disable tax */,
      },
    });
  };

  handleDate = selected => {
    // console.log(selected);
    this.setState({
      value: {
        ...this.state.value,
        crExpirydate: selected,
      },
    });
  };

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;

    if (name === 'orgName') {
      this.setState({
        ...this.state,
        orgNameError: '',
        value: {...this.state.value, orgName: value},
      });
    } else if (name === 'email') {
      // console.log();
      this.setState({
        ...this.state,
        emailError: '',
        value: {...this.state.value, email: value},
      });
    } else if (name === 'mobno') {
      this.setState({
        ...this.state,
        mobnoError: '',
        value: {...this.state.value, mobno: value},
      });
    } else if (name === 'password') {
      this.setState({
        ...this.state,
        passwordError: '',
        value: {...this.state.value, password: value},
      });
    } else if (name === 'conf_pwd') {
      this.setState({
        ...this.state,
        confPwdError: '',
        value: {...this.state.value, confPwd: value},
      });
    } else if (name === 'country') {
      if (value !== 'select') {
        let countryDetails = JSON.parse(value);
        // console.log(countryDetails);
        this.setState({
          ...this.state,
          countryError: '',
          value: {
            ...this.state.value,
            country: countryDetails.countryId.id,
            currCode:
              countryDetails.currencyId &&
              countryDetails.currencyId.iso4217Code,
            currencyId:
              countryDetails.currencyId && countryDetails.currencyId.id,
            countryCode:
              countryDetails.countryId && countryDetails.countryId.callingCode,
          },
        });
      } else {
        this.setState({
          value: {
            ...this.state.value,
            currCode: '',
            currencyId: '',
            countryCode: '',
          },
        });
      }
    } else if (name === 'states') {
      this.setState(
        {
          ...this.state,
          statesError: '',
          value: {...this.state.value, states: value},
        },
        () => {
          this.props.fetchDistrictById(value);
        }
      );
    } else if (name === 'district') {
      this.setState({
        ...this.state,
        districtError: '',
        value: {...this.state.value, district: value},
      });
    } else if (name === 'address1') {
      this.setState({
        ...this.state,
        address1Error: '',
        value: {...this.state.value, address1: value},
      });
    } else if (name === 'address2') {
      this.setState({
        value: {...this.state.value, address2: value},
      });
    } else if (name === 'landmark') {
      this.setState({
        value: {...this.state.value, landmark: value},
      });
    } else if (name === 'city') {
      this.setState({
        value: {...this.state.value, city: value},
      });
    } else if (name === 'zip') {
      this.setState({
        value: {...this.state.value, zip: value},
      });
    } else if (name === 'glCode') {
      this.setState({
        value: {...this.state.value, glCode: value},
      });
    } else if (name === 'gstin') {
      this.setState({
        ...this.state,
        gstError: '',
        value: {...this.state.value, gstin: value},
      });
    } else if (name === 'crno') {
      this.setState({
        value: {...this.state.value, crno: value},
      });
    } else if (name === 'crExpirydate') {
      this.setState({
        value: {...this.state.value, crExpirydate: value},
      });
    } else if (name === 'fname') {
      this.setState({
        ...this.state,
        fnameError: '',

        value: {...this.state.value, fname: value},
      });
    } else if (name === 'lname') {
      this.setState({
        ...this.state,
        lnameError: '',
        value: {...this.state.value, lname: value},
      });
    } else if (name === 'cont_num') {
      this.setState({
        value: {...this.state.value, contNum: value},
      });
    } else if (name === 'spoc_name') {
      this.setState({
        value: {...this.state.value, spocName: value},
      });
    } else if (name === 'spoc_desig') {
      this.setState({
        value: {...this.state.value, spocDesign: value},
      });
    } else if (name === 'spoc_email') {
      this.setState({
        value: {...this.state.value, spocEmail: value},
      });
    } else if (name === 'spoc_phone') {
      this.setState({
        value: {...this.state.value, spocPhone: value},
      });
    } else if (name === 'hq_add') {
      this.setState({
        value: {...this.state.value, hqAdd: value},
      });
    } else if (name === 'hq_fax') {
      this.setState({
        value: {...this.state.value, hqFax: value},
      });
    } else if (name === 'hq_email') {
      this.setState({
        value: {...this.state.value, hqEmail: value},
      });
    } else if (name === 'hq_phone') {
      this.setState({
        value: {...this.state.value, hqPhone: value},
      });
    } else if (name === 'taxPercent') {
      this.setState({
        value: {
          ...this.state.value,
          taxPercent: this.state.isHidden ? 0 : value,
        },
      });
    } else if (name === 'commission_per') {
      this.setState({
        value: {...this.state.value, commPer: value},
      });
    } else if (name === 'org_logo') {
      // let value = event.target.files[0];
      let formdata = new FormData();
      formdata.append(value, value);
      this.setState({
        value: {...this.state.value, orgLogo: value},
      });
    }
  };

  closeModel = () => {
    this.setState({
      value: {
        orgName: '',
        email: '',
        mobno: '',
        password: '',
        country: '',
        states: '',
        district: '',
        address1: '',
        address2: '',
        landmark: '',
        city: '',
        zip: '',
        glCode: '',
        gstin: '',
        currCode: '',
        currencyId: '',
        crno: '',
        crExpirydate: '',
        fname: '',
        lname: '',
        countryCode: '',
        contNum: '',
        spocName: '',
        spocDesign: '',
        spocEmail: '',
        spocPhone: '',
        hqAdd: '',
        hqFax: '',
        hqEmail: '',
        hqPhone: '',
        taxPercent: '',
        commPer: '',
        orgLogo: '',
        isEnabled: false,
      },
      isHidden: true,
      fnameError: '',
      lnameError: '',
      emailError: '',
      passwordError: '',
      confPwdError: '',
      orgNameError: '',
      address1Error: '',
      mobnoError: '',
      countryError: '',
      statesError: '',
      districtError: '',
      gstError: '',
    });
    this.props.closeAddModel();
  };

  validate = () => {
    let isError = false;
    let regex = /[a-z]|[a-z]\s/i;
    let regexcode = /^[0-9]|[0-9]\s/;
    let regexemail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    let regexrange = /\b([0-9]|[1-9][0-9]|100)\b/;
    let gstregex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const errmsg1 = 'Enter a valid input';
    const errmsg2 = 'This is a mandatory field';
    const errmsg3 = 'Password mismatch.Please re-enter';
    const errmsg4 = 'Please confirm password';
    const errmsg5 = ' Password must contain atleast 6 characters';
    const errmsg6 = 'Enter a value between 0-100';
    const errmsg7 = 'Entered GST is not in valid format';

    const errors = {
      fnameError: '',
      lnameError: '',
      emailError: '',
      passwordError: '',
      confPwdError: '',
      orgNameError: '',
      address1Error: '',
      mobnoError: '',
      countryError: '',
      statesError: '',
      districtError: '',
      gstError: '',
    };

    if (this.state.value.fname === '') {
      isError = true;
      errors.fnameError = errmsg2;
    }
    if (this.state.value.fname !== '' && !regex.test(this.state.value.fname)) {
      isError = true;
      errors.fnameError = errmsg1;
    }

    if (!regex.test(this.state.value.lname)) {
      isError = true;
      errors.lnameError = errmsg1;
    }
    if (this.state.value.lname === '') {
      isError = true;
      errors.lnameError = errmsg2;
    }
    if (!regexemail.test(this.state.value.email)) {
      isError = true;
      errors.emailError = errmsg1;
    }
    if (this.state.value.email === '') {
      isError = true;
      errors.emailError = errmsg2;
    }
    if (this.state.value.password === '') {
      isError = true;
      errors.passwordError = errmsg2;
    }
    if (
      this.state.value.confPwd &&
      this.state.value.confPwd !== this.state.value.password
    ) {
      isError = true;
      errors.confPwdError = errmsg3;
    }
    if (
      this.state.value.password !== '' &&
      this.state.value.password.length < 6
    ) {
      isError = true;
      errors.passwordError = errmsg5;
    }
    if (
      this.state.value.password.length >= 6 &&
      this.state.value.confPwd === ''
    ) {
      isError = true;
      errors.confPwdError = errmsg4;
    }
    if (this.state.value.orgName === '') {
      isError = true;
      errors.orgNameError = errmsg2;
    }
    if (this.state.value.address1 === '') {
      isError = true;
      errors.address1Error = errmsg2;
    }
    if (this.state.value.mobno === '') {
      isError = true;
      errors.mobnoError = errmsg2;
    }
    if (
      this.state.value.mobno !== '' &&
      !regexcode.test(this.state.value.mobno)
    ) {
      isError = true;
      errors.mobnoError = errmsg1;
    }
    if (
      this.state.value.country === '' ||
      this.state.value.country === 'select'
    ) {
      isError = true;
      errors.countryError = errmsg2;
    }
    if (
      this.state.value.states === '' ||
      this.state.value.states === 'select'
    ) {
      isError = true;
      errors.statesError = errmsg2;
    }
    if (
      this.state.value.district === '' ||
      this.state.value.district === 'select'
    ) {
      isError = true;
      errors.districtError = errmsg2;
    }
    if (this.state.value.gstin === '') {
      isError = true;
      errors.gstError = errmsg2;
    }
    if (
      this.state.value.gstin !== '' &&
      !gstregex.test(this.state.value.gstin)
    ) {
      isError = true;
      errors.gstError = errmsg7;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  submit = () => {
    let data = this.state.value;
    // console.log(data);

    const err = this.validate();

    if (!err) {
      this.props.AddLicenseeProfile(this.state.value);
      this.setState({
        value: {
          orgName: '',
          email: '',
          mobno: '',
          password: '',
          country: '',
          states: '',
          district: '',
          address1: '',
          address2: '',
          landmark: '',
          city: '',
          zip: '',
          glCode: '',
          gstin: '',
          currCode: '',
          currencyId: '',
          crno: '',
          crExpirydate: '',
          fname: '',
          lname: '',
          countryCode: '',
          contNum: '',
          spocName: '',
          spocDesign: '',
          spocEmail: '',
          spocPhone: '',
          hqAdd: '',
          hqFax: '',
          hqEmail: '',
          hqPhone: '',
          taxPercent: '',
          commPer: '',
          orgLogo: '',
          isEnabled: false,
        },
        isHidden: true,
        fnameError: '',
        lnameError: '',
        emailError: '',
        passwordError: '',
        confPwdError: '',
        orgNameError: '',
        address1Error: '',
        mobnoError: '',
        countryError: '',
      });
      this.props.closeAddModel();
      this.props.resetPage();
    }
  };

  render() {
    return (
      <div>
        <Modal
          show={this.props.showAddModel}
          onHide={this.closeModel}
          animation={false}
          size="lg"
          backdrop="static"
        >
          <Modal.Header
            style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
            closeButton
          >
            <Modal.Title>
              <span style={{fontSize: '20px'}}>Add Licensee</span>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Form>
                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="fname">
                      <Form.Label className="mandatoryField">
                        First Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="fname"
                        value={this.state.value.fname}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.fnameError}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="lname">
                      <Form.Label className="mandatoryField">
                        Last Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="lname"
                        value={this.state.value.lname}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.lnameError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group as={Row} controlId="email">
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Label className="mandatoryField">Email ID</Form.Label>
                    <Form.Control
                      type="text"
                      autoComplete="off"
                      name="email"
                      value={this.state.value.email}
                      onChange={this.onChange}
                    />
                    <div className="errStyle">
                      {this.state.emailError}
                    </div>
                  </Col>
                </Form.Group>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="password">
                      <Form.Label className="mandatoryField">
                        Password
                      </Form.Label>
                      <Form.Control
                        type="password"
                        name="password"
                        value={this.state.value.password}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.passwordError}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="conf_pwd">
                      <Form.Label className="mandatoryField">
                        Confirm Password
                      </Form.Label>
                      <Form.Control
                        type="password"
                        name="conf_pwd"
                        value={this.state.value.confPwd}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.confPwdError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="orgName">
                      <Form.Label className="mandatoryField">
                        Organization Name
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="orgName"
                        value={this.state.value.orgName}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.orgNameError}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="country">
                      <Form.Label className="mandatoryField">
                        Country
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="country"
                        onChange={this.onChange}
                        // value={this.state.value.country}
                      >
                        <option value="select">Select Country</option>
                        {this.props.cntrycrncyList &&
                          this.props.cntrycrncyList.map((item, i) =>
                            <option key={i} value={JSON.stringify(item)}>
                              {/* value={item.id} */}
                              {item.countryId !== null && item.countryId.name}
                            </option>
                          )}
                      </Form.Control>
                      <div className="errStyle">
                        {this.state.countryError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="states">
                      <Form.Label className="mandatoryField">State</Form.Label>
                      <Form.Control
                        as="select"
                        name="states"
                        onChange={this.onChange}
                      >
                        <option value="">Select State</option>
                        {this.props.statesList &&
                          this.props.statesList.map((item, i) =>
                            <option key={i} value={item.id}>
                              {item.name}
                            </option>
                          )}
                      </Form.Control>
                      <div className="errStyle">
                        {this.state.statesError}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="district">
                      <Form.Label className="mandatoryField">
                        District
                      </Form.Label>
                      <Form.Control
                        as="select"
                        name="district"
                        onChange={this.onChange}
                      >
                        <option value="">Select District</option>
                        {this.props.districtById &&
                          this.props.districtById.map((item, i) =>
                            <option key={i} value={item.id}>
                              {item.name}
                            </option>
                          )}
                      </Form.Control>
                      <div className="errStyle">
                        {this.state.districtError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="city">
                      <Form.Label className="">City</Form.Label>
                      <Form.Control
                        type="text"
                        name="city"
                        autoComplete="off"
                        value={this.state.value.city}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group>
                      <Form.Label className="mandatoryField">
                        Mobile No
                      </Form.Label>
                      <Row>
                        <Col
                          lg={4}
                          md={4}
                          sm={4}
                          xs={4}
                          style={{paddingRight: '0px'}}
                        >
                          <Form.Control
                            style={{textAlign: 'right'}}
                            className="readOnlyStyle"
                            name="cont_code"
                            readOnly={true}
                            /* plaintext */
                            value={this.state.value.countryCode}
                          />
                        </Col>
                        <Col
                          lg={8}
                          md={8}
                          sm={8}
                          xs={8}
                          style={{paddingLeft: '0px'}}
                        >
                          <Form.Control
                            type="text"
                            name="mobno"
                            autoComplete="off"
                            required={true}
                            value={this.state.value.mobno}
                            readOnly={false}
                            onChange={this.onChange}
                          />
                        </Col>
                      </Row>
                      <div className="errStyle">
                        {this.state.mobnoError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="address1">
                      <Form.Label className="mandatoryField">
                        Address 1
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="address1"
                        autoComplete="off"
                        value={this.state.value.address1}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.address1Error}
                      </div>
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="address2">
                      <Form.Label className="">Address 2</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="address2"
                        value={this.state.value.address2}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="landmark">
                      <Form.Label className="">Landmark</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="landmark"
                        autoComplete="off"
                        rows="1"
                        value={this.state.value.landmark}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="zip">
                      <Form.Label className="">Zip Code</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="zip"
                        value={this.state.value.zip}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  {/*  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="glCode">
                      <Form.Label className="">GL Code</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="glCode"
                        value={this.state.value.glCode}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col> */}
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="gstin">
                      <Form.Label className="mandatoryField">GSTIN</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="gstin"
                        value={this.state.value.gstin}
                        onChange={this.onChange}
                      />
                      <div className="errStyle">
                        {this.state.gstError}
                      </div>
                    </Form.Group>
                  </Col>
                </Row>

                {/* <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="crno">
                      <Form.Label className="">CR No</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="crno"
                        value={this.state.value.crno}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="crExpirydate">
                      <Form.Label className="">CR Expiry Date</Form.Label>
                      <br />
                      <div className="datepickerDiv">
                        <DatePicker
                          className="ExpdatePicker"
                          autoComplete="off"
                          selected={this.state.value.crExpirydate}
                          onChange={this.handleDate}
                          name="crExpirydate"
                          dateFormat="dd-MM-yyyy"
                          minDate={new Date()}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                </Row> */}

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_name">
                      <Form.Label className="">Contact Person</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_name"
                        value={this.state.value.spocName}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_desig">
                      <Form.Label className="">Designation</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_desig"
                        value={this.state.value.spocDesign}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_email">
                      <Form.Label className="">Contact Email</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_email"
                        value={this.state.value.spocEmail}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="spoc_phone">
                      <Form.Label className="">Contact No(Mobile)</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="spoc_phone"
                        value={this.state.value.spocPhone}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_add">
                      <Form.Label className="">Headquarters Address</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="hq_add"
                        value={this.state.value.hqAdd}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_fax">
                      <Form.Label className="">Headquarters Fax</Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="hq_fax"
                        value={this.state.value.hqFax}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_email">
                      <Form.Label className="">
                        Headquarters Email ID
                      </Form.Label>
                      <Form.Control
                        type="email"
                        autoComplete="off"
                        name="hq_email"
                        value={this.state.value.hqEmail}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="hq_phone">
                      <Form.Label className="">
                        Headquarters Contact No
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autoComplete="off"
                        name="hq_phone"
                        value={this.state.value.hqPhone}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Form.Group as={Row} controlId="tax_pay">
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Label className="">Tax Enable</Form.Label>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Switch
                      onChange={this.handleChange}
                      onColor="#20a8d8"
                      checked={this.state.value.isEnabled}
                    />
                  </Col>
                </Form.Group>

                <Form.Group
                  as={Row}
                  style={{display: this.state.isHidden ? 'none' : null}}
                  controlId="taxPercent"
                >
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Label className="">Tax Percentage</Form.Label>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Control
                      type="number"
                      autoComplete="off"
                      name="taxPercent"
                      min={0}
                      max={100}
                      value={this.state.value.taxPercent}
                      onChange={this.onChange}
                    />
                  </Col>
                </Form.Group>

                <Row>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="curr_code">
                      <Form.Label className="">Currency Code</Form.Label>
                      <Form.Control
                        className="readOnlyStyle"
                        type="text"
                        name="curr_code"
                        readOnly={true}
                        value={this.state.value.currCode}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={6} sm={12} xs={12}>
                    <Form.Group controlId="commission_per">
                      <Form.Label className="">
                        Commission Percentage
                      </Form.Label>
                      <Form.Control
                        type="number"
                        autoComplete="off"
                        min={0}
                        max={100}
                        name="commission_per"
                        value={this.state.value.commPer}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                {/* <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <Form.Group controlId="org_logo">
                      <Form.Label className="">
                        Organization Logo
                      </Form.Label>
                      <Form.Control
                        type="file"
                        name="org_logo"
                        accept="image/*"
                        value={this.state.value.orgLogo}
                        onChange={this.onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row> */}

                {/* <div className="mb-3">
                  <Form.File id="formcheck-api-regular">
                    <Form.File.Label>Regular file input</Form.File.Label>
                    <Form.File.Input />
                  </Form.File>
                </div> */}
              </Form>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{backgroundColor: '#f0f3f5'}}>
            <Button type="submit" onClick={this.submit}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default AddLicensee;
